import React from 'react';
import '../styling/LayoutCommon.module.css';

export default function Header (props) {
	return (
		<h2 style={{ padding: '0.5em 0.5em 0.4em 1em', marginBottom: 0 }}>{ props.title }</h2>
	)
}